import React from 'react';

import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/models';

import NewsClips from './news-clips';

const NewsClipsWidget = ({ sections }) => {
  const { delay, content } = sections.find(
    (section) => section.fields?.slug === 'news-clips-carousel'
  )?.fields;

  const clips = content?.map(({ fields }) => ({
    logo: fields?.image,
    source: fields?.title,
    quote: fields?.bodyContent,
  }));

  return <NewsClips delay={delay} clips={clips} />;
};

NewsClipsWidget.propTypes = widgetPropType;
NewsClipsWidget.defaultProps = widgetDefaultProps;

export default NewsClipsWidget;
